import React from "react";
import UniversalTableLiteWeb from "../../../common/UniversalTableLiteWeb";
import ContentSection from "../../../common/ContentSection";
import withTranslations from "../../../../../hocs/withTranslations";
import PageTitle from "../../../common/PageTitle";
import ResourceResolver from "../../../../../lib/UniversalTable/ResourceResolver";
import { compose } from "redux";
import withUserData from "../../../../../hocs/withUserData";
import { PLAN_PERMISSIONS_SECTIONS } from "../../../../../redux/modules/auth/userPermissions/selector";
import UpgradePlansWrapper from "../../../landingPage/pages/Plans/components/UpgradePlanWrapper";

const TurtleStrategyTablePage = ({ translate, hasPermission }) => {
  if (!hasPermission(PLAN_PERMISSIONS_SECTIONS.TURTLE_STRATEGY_SUMMARY)) {
    return (
      <ContentSection>
        <UpgradePlansWrapper
          permissions={PLAN_PERMISSIONS_SECTIONS.TURTLE_STRATEGY_SUMMARY}
        />
      </ContentSection>
    );
  }

  return (
    <ContentSection>
      <PageTitle title={translate("turtle_strategy_summary_page_title")} />
      <h1>{translate("turtle_strategy_summary_header")}</h1>
      <p
        dangerouslySetInnerHTML={{
          __html: translate("turtle_strategy_summary_description")
        }}
      />
      <UniversalTableLiteWeb
        resourceId={ResourceResolver["turtle_strategy_summary"]}
        useUrlSettings
      />
    </ContentSection>
  );
};

export default compose(withUserData, withTranslations)(TurtleStrategyTablePage);
